'use client';

import { SearchBar } from './search-bar';

export const SearchBarContainer = ({
  isMobile,
  isFeatureFlag,
  size,
  children,
  isHeadlessPDPEnabled,
  model,
  serialNumber,
  isHeadlessCategoryEnabled,
  isFederatedSearchEnabled,
  isSearchBarInHeader
}: {
  isMobile?: boolean;
  isFeatureFlag: boolean;
  size?: 'lg' | 'md' | 'sm';
  children?: React.ReactNode;
  isHeadlessPDPEnabled: boolean;
  model?: string;
  serialNumber?: string;
  isHeadlessCategoryEnabled: boolean;
  isFederatedSearchEnabled: boolean;
  isSearchBarInHeader: boolean;
}) => {
  return (
    <SearchBar
      isMobile={isMobile}
      isFeatureFlag={isFeatureFlag}
      size={size}
      isHeadlessPDPEnabled={isHeadlessPDPEnabled}
      model={model}
      serialNumber={serialNumber}
      isHeadlessCategoryEnabled={isHeadlessCategoryEnabled}
      isFederatedSearchEnabled={isFederatedSearchEnabled}
      isSearchBarInHeader={isSearchBarInHeader}
    >
      {children}
    </SearchBar>
  );
};
